/**
 * Entry application component used to compose providers and render Routes.
 * */

import React ,{useRef,useEffect} from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Routes } from "./Routes";
import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import packageJson from "../../package.json";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import DOMPurify from 'dompurify';
import ToastManager from "../_metronic/_partials/widgets/ToastManager";

// keep reference to original
const _origError = toast.error;

toast.error = (content, options = {}) => {
  if (React.isValidElement(content)) {
    return _origError(content, options);
  }

  const safeHtml = DOMPurify.sanitize(String(content));

  return _origError(
    <div dangerouslySetInnerHTML={{ __html: safeHtml }} />,
    options // 🔥 forward all options untouched
  );
};

const buildDateGreaterThan = (latestDate, currentDate) => {
  const momLatestDateTime = moment(latestDate);
  const momCurrentDateTime = moment(currentDate);

  if (momLatestDateTime.isAfter(momCurrentDateTime)) {
    return true;
  } else {
    return false;
  }
};
export default function App({ store, persistor, basename }) {
  const dataFetchedRef = useRef(false);
  const logStoredRef = useRef(false)
  const paymentSuccessNewRef = useRef(false)
  useEffect(() => {
    fetch("/meta.json")
      .then((response) => response.json())
      .then((meta) => {

        const latestVersionDate = meta.buildDate;
        const currentVersionDate = packageJson.buildDate;

        const shouldForceRefresh = buildDateGreaterThan(
          latestVersionDate,
          currentVersionDate
        );
        if (shouldForceRefresh) {
          if (caches) {
            // Service worker cache should be cleared with caches.delete()
            caches.keys().then((names) => {
              for (const name of names) {
                caches.delete(name);
              }
            });
            window.location.reload(true);
          }
        }
      });
  }, []);
  return (
    /* Provide Redux store */
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
        <React.Suspense fallback={<LayoutSplashScreen />}>
          {/* Override `basename` (e.g: `homepage` in `package.json`) */}
          <BrowserRouter basename={basename}>
            {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
            <MaterialThemeProvider>
              {/* Provide `react-intl` context synchronized with Redux state.  */}
              <I18nProvider>
                {/* Render routes with provided `Layout`. */}
                <Routes dataFetchedRef={dataFetchedRef} logStoredRef={logStoredRef} paymentSuccessNewRef={paymentSuccessNewRef}/>
                <ToastManager />
                {/* <ToastContainer 
                  containerId="global-toast"
                  position = {toast.POSITION.TOP_RIGHT}
                  autoClose = {4000}
                  hideProgressBar = {false}
                  closeOnClick = {true}
                  pauseOnHover = {true}
                  draggable = {true}
                  limit = {3}
                /> */}
              </I18nProvider>
            </MaterialThemeProvider>
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
